import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";
import QRCodeReact from "react-qr-code";
import html2canvas from "html2canvas";
import { format } from "date-fns";
import { fetchSocialPosts } from "@socialAction";
import { fetchEventUserCategories, fetchAppuserDetails } from "@ticketsaction";
import { _uploadSocialBanner } from "@registrationaction";
import { CDN_BASE_IMAGES_URL, COMMON_REDIRECT_URI } from "@constant";
import linkedinIcon from "../../../assets/image/linkedin2.svg";
import facebookIcon from "../../../assets/image/facebook2.svg";
import { classNames } from "@utilscommon";
import userIcon from "../../../assets/image/user_1.png";
import arrowIcon from "../../../assets/icons/arrowIcon.svg";
import tickIcon from "../../../assets/image/white-tick.svg";
import LocaleStrings from "@language";
import { useLocalStorage, LOCAL_STORAGE } from "@useLocalStorage";
import { useSocialMedia } from "@useSocialMedia";
import { webportalURL } from "@utilscommon";

function SocialShare({ calledFrom = "ticket", locationState = {} }) {
  const { getLocalStorage } = useLocalStorage();
  const { shareMediaPost, postLoading } = useSocialMedia();
  const dispatch = useDispatch();
  const session = useSelector((state) => state.session);
  const orderData = useSelector((state) => state.orderData);
  const eventData = useSelector((state) => state.eventData);
  const eventUserCategories = useSelector((state) => state.eventUserCategories);
  const socialDetails = getLocalStorage(LOCAL_STORAGE.USER_SOCIAL_DETAILS);
  const [socialposts, setSocialPosts] = useState([]);
  const [selectedIDX, setSelectedIDX] = useState(0);
  const [loading, setLoading] = useState("");
  const containerRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const fromThankyouPage = calledFrom === "registration";
  const [matched, setMatched] = useState({});
  const [modal, setModal] = useState({ show: false, type: "" });
  const [image, setImage] = useState("");
  const [caption, setCaption] = useState("");
  const previewData = useRef({});
  const [sessions, setSessions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (calledFrom === "registration") {
      if (locationState?.appuserid) {
        dispatch(
          fetchAppuserDetails(session, locationState?.appuserid, (res) => {
            if (res.success) {
              setMatched(res.data?.[0]);
              setSessions(res.sessions);
              const ids = _.uniq(
                res.data?.[0]?.usercategory
                  ? res.data?.[0]?.usercategory?.split(",")?.map(Number)
                  : []
              );
              const body = {
                type: "shareContents",
                eventid: session.eventid,
                groupids: ids,
              };
              dispatch(
                fetchSocialPosts(session, body, (res) => setSocialPosts(res))
              );
            }
          })
        );
      }
    }
    if (orderData && orderData?.data?.orderdetails?.length > 0) {
      let matchedData = orderData?.data?.orderdetails?.find(
        (ea) => ea.email == orderData?.data?.email
      );
      if (matchedData) {
        setMatched(matchedData);
        setSessions(matchedData?.sessions ?? []);
      }
      if (matchedData?.appuserid) {
        dispatch(
          fetchAppuserDetails(session, matchedData?.appuserid, (res) => {
            if (res.success) {
              setMatched(res.data?.[0]);
              setSessions(res.sessions);
              const ids = _.uniq(
                res.data?.[0]?.usercategory
                  ? res.data?.[0]?.usercategory?.split(",")?.map(Number)
                  : []
              );
              const body = {
                type: "shareContents",
                eventid: session.eventid,
                groupids: ids,
              };
              dispatch(
                fetchSocialPosts(session, body, (res) => setSocialPosts(res))
              );
            }
          })
        );
      } else {
        const ids = _.uniq(
          _.flatMap(
            _.filter(
              orderData.data.orderdetails,
              (ea) => ea.email == orderData?.data?.email
            ),
            (e) =>
              e.usercategory_csv
                ? e?.usercategory_csv?.split(",")?.map(Number)
                : []
          )
        );

        if (!_.isEmpty(ids)) {
          const body = {
            type: "shareContents",
            eventid: session.eventid,
            groupids: ids,
          };
          dispatch(
            fetchSocialPosts(session, body, (res) => setSocialPosts(res))
          );
        }
      }
    }
    _.isEmpty(eventUserCategories) &&
      dispatch(fetchEventUserCategories(session, () => {}));
  }, [orderData]);


  const prepareShareData = async (media) => {
    const clone = containerRef?.current;
    if (!clone) return;
    setLoading(media);
    if (media == "linkedin") {
      html2canvas(clone, {
        useCORS: true,
        scale: 5,
        backgroundColor: "white",
      })
        .then((canvas) => {
          setLoading("");
          const dataUrl = canvas.toDataURL("image/jpeg", 1);
          if (dataUrl !== "") {
            setImage(dataUrl);
            setCaption(socialposts?.[selectedIDX]?.description ?? "");
            setModal({ show: true, type: media });
          }
        })
        .catch((error) => {});
    } else {
      // Create an offscreen clone
      const clonedNode = clone.cloneNode(true);
      Object.assign(clonedNode.style, {
        position: "absolute",
        left: "-9999px",
        top: "-9999px",
        width: "1200px", // Set the width to 1200px
        height: "630px", // Set the height to 630px
        backgroundColor: "white",
        transform: "none", // Remove scaling transformation
      });

      document.body.appendChild(clonedNode);
      const copyComputedStyles = (source, target) => {
        const styles = window.getComputedStyle(source);
        Array.from(styles).forEach((key) => {
          target.style[key] = styles.getPropertyValue(key);
        });
        [...source.children].forEach((child, index) =>
          copyComputedStyles(child, target.children[index])
        );
      };
      copyComputedStyles(clone, clonedNode);

      html2canvas(clonedNode, {
        useCORS: true,
        scale: 5,
        backgroundColor: "white",
      })
        .then((canvas) => {
          document.body.removeChild(clonedNode);
          const newCanvas = document.createElement("canvas");
          const ctx = newCanvas.getContext("2d");
          newCanvas.width = 1200;
          newCanvas.height = 630;

          const scale = newCanvas.height / canvas.height;
          const newWidth = canvas.width * scale;
          const offsetX = (newCanvas.width - newWidth) / 2;

          ctx.fillStyle = "white";
          ctx.fillRect(0, 0, newCanvas.width, newCanvas.height);

          ctx.drawImage(canvas, offsetX, 0, newWidth, newCanvas.height);

          const dataUrl = newCanvas.toDataURL("image/jpg", 1);
          if (!_.isEmpty(dataUrl)) {
            dispatch(
              _uploadSocialBanner(session, dataUrl, (res) => {
                setLoading("");
                if (res?.success) {
                  const img = res?.data?.path;
                  const state = encodeURIComponent(
                    JSON.stringify({
                      type: "share",
                      url: webportalURL(eventData.seocode),
                      title: socialposts?.[selectedIDX]?.description,
                      image: `${CDN_BASE_IMAGES_URL}/${img}`,
                    })
                  );
                  const fixedURL = encodeURIComponent(
                    `${COMMON_REDIRECT_URI}?state=${state}&type=share`
                  );
                  const mediaURLs = {
                    facebook: `https://www.facebook.com/sharer.php?u=${fixedURL}`,
                    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${fixedURL}`,
                    twitter: `https://twitter.com/intent/tweet?url=${fixedURL}&text=${encodeURIComponent(
                      socialposts?.[selectedIDX]?.description
                    )}`,
                  };

                  const shareURL = mediaURLs[media] || mediaURLs.twitter;
                  const newTab = window.open(
                    shareURL,
                    "_blank",
                    "width=600,height=700,left=100,top=100,resizable,scrollbars"
                  );
                  if (media === "twitter") {
                    setTimeout(() => {
                      newTab.location.href = shareURL;
                    }, 4000);
                  }
                }
              })
            );
            // sendImageToPHP(dataUrl).then((img) => {});
          }
        })
        .catch((error) => setLoading(""));
    }
  };

  const renderTexts = (value, boostgroupid) => {
    let identifierString = value.name;
    const username = orderData?.data?.username?.split(" ");
    let userDetails = !_.isEmpty(socialDetails)
      ? socialDetails
      : {
          firstname: username?.[0],
          lastname: username?.[1],
          username: orderData?.data?.username,
          profileurl: "",
          email: orderData?.data?.email,
        };

    if (fromThankyouPage && !_.isEmpty(locationState)) {
      userDetails = locationState;
      userDetails.username = `${locationState?.firstname} ${locationState?.lastname}`;
    }

    if (matched && matched.profileurl) {
      userDetails.profileurl = matched.profileurl;
    }
    if (matched) {
      userDetails.username = `${matched?.firstname} ${matched?.lastname}`;
      userDetails.firstname = matched?.firstname;
      userDetails.lastname = matched?.lastname;
      userDetails.email = matched?.email;
      userDetails.usercategory_name = matched?.usercategory_name;
    }

    let userResponse = matched ? matched?.responses : null;
    let sponsor = matched ? matched?.sponsor_by_sponsoridfk : null;
    let exhibitor = matched ? matched?.exhibitors_by_exhibitoridfk : null;
    let speaker = matched ? matched?.speaker_by_speakeridfk : null;

    let text = "";
    if (identifierString === "#event_name") {
      text = eventData.eventname;
    } else if (identifierString === "#event_location" && eventData.country) {
      text = eventData.country;
    } else if (
      identifierString === "#profil_logo" &&
      userDetails?.profileurl &&
      userDetails?.profileurl !== ""
    ) {
      text = userDetails?.profileurl;
    } else if (identifierString === "#first_name" && userDetails?.firstname) {
      text = userDetails?.firstname;
    } else if (identifierString === "#last_name" && userDetails?.lastname) {
      text = userDetails?.lastname;
    } else if (identifierString === "#full_name" && userDetails?.username) {
      text = userDetails?.username;
    } else if (identifierString === "#designation") {
      let jsonData = userResponse ? JSON.parse(userResponse) : [];
      let match = jsonData.filter((obj) => {
        return obj.name === "designation";
      });
      let designation =
        match.length > 0 && match[0].value
          ? match[0].value
          : userDetails?.designation ?? "";
      text = designation;
    } else if (identifierString === "#company_name") {
      let jsonData = userResponse ? JSON.parse(userResponse) : [];
      let match = jsonData.filter((obj) => {
        return obj.name === "company";
      });
      let company =
        match.length > 0 && match[0].value
          ? match[0].value
          : userDetails?.company ?? "";
      text = company;
    } else if (identifierString === "#primary_group") {
      text = userDetails?.usercategory_name?.split(",")?.[0] ?? "";
    } else if (identifierString === "#registration_type") {
      let regType =
        userDetails?.comesfrom === "admin_panel"
          ? "Admin"
          : userDetails?.comesfrom === "ticket"
          ? "Ticket"
          : userDetails?.comesfrom === "api"
          ? "Api"
          : userDetails?.comesfrom === "open_registration"
          ? "Open Registration"
          : userDetails?.comesfrom === "proposal"
          ? "Abstract"
          : "N/A";
      text = regType;
    } else if (identifierString === "#sessiontitle") {
      text =
        sessions.length && sessions[currentIndex]
          ? sessions[currentIndex].title
          : "";
    } else if (identifierString === "#sessiondescription") {
      text =
        sessions.length && sessions[currentIndex]
          ? sessions[currentIndex].description ?? ""
          : "";
    } else if (identifierString === "#sessionlocation") {
      text =
        sessions.length && sessions[currentIndex]
          ? sessions[currentIndex].location ?? ""
          : "";
    } else if (identifierString === "#sessiontime") {
      text =
        sessions.length && sessions[currentIndex]?.starttime
          ? format(new Date(sessions[currentIndex].starttime), "PP")
          : "";
    } else if (identifierString === "#sessiondate") {
      text =
        sessions.length &&
        sessions[currentIndex]?.starttime &&
        sessions[currentIndex]?.endtime
          ? `${format(
              new Date(sessions[currentIndex].starttime),
              "HH:mm"
            )} - ${format(new Date(sessions[currentIndex].endtime), "HH:mm")}`
          : "";
    } else if (identifierString === "#spn_name") {
      text = sponsor ? sponsor.name : "";
    } else if (identifierString === "#spn_description") {
      text = sponsor ? sponsor.description ?? "" : "";
    } else if (identifierString === "#spn_sponsoremail") {
      text = sponsor ? sponsor.sponsoremail ?? "" : "";
    } else if (identifierString === "#exh_name") {
      text = exhibitor ? exhibitor.name : "";
    } else if (identifierString === "#exh_booth") {
      text = exhibitor ? exhibitor.booth ?? "" : "";
    } else if (identifierString === "#exh_about") {
      text = exhibitor ? exhibitor.about : "";
    } else if (identifierString === "#exh_country") {
      text = exhibitor ? exhibitor.country ?? "" : "";
    } else if (identifierString === "#exh_industry") {
      text = exhibitor ? exhibitor.industry ?? "" : "";
    } else if (identifierString === "#spk_firstname") {
      text = speaker ? speaker.firstname : "";
    } else if (identifierString === "#spk_lastname") {
      text = speaker ? speaker.lastname : "";
    } else if (identifierString === "#spk_position") {
      text = speaker ? speaker.position ?? "" : "";
    } else if (identifierString === "#spk_company") {
      text = speaker ? speaker.company ?? "" : "";
    } else if (identifierString === "#spk_email") {
      text = speaker ? speaker.email ?? "" : "";
    } else if (identifierString === "#spk_phone") {
      text = speaker ? speaker.phone ?? "" : "";
    } else if (identifierString === "#spk_country") {
      text = speaker ? speaker.country ?? "" : "";
    } else if (identifierString === "#spk_description") {
      text = speaker ? speaker.description ?? "" : "";
    } else {
      if (
        value.iscustom === true &&
        value.htmlType === "input" &&
        value.textValue
      ) {
        if (
          value.textValue.indexOf("{{") > -1 &&
          value.textValue.indexOf("}}") > -1
        ) {
          let rep = value.textValue.replace(/[{}]/g, "").trim();
          let rep_match = value.textValue.match(/\{\{(.*?)\}\}/);
          if (rep_match && rep_match.length) {
            rep = rep_match[0].replace(/[{}]/g, "").trim();
          }
          let customVal = "";

          if (rep === "interest") {
            customVal = "";
          } else {
            const grouptype = eventUserCategories?.data?.find((c) =>
              _.isEqual(c.id, Number(boostgroupid))
            )?.type;

            let jsonData = userResponse ? JSON.parse(userResponse) : null;
            if (
              _.isEqual(grouptype, "exhibitor") &&
              exhibitor &&
              exhibitor.responses
            ) {
              jsonData = JSON.parse(exhibitor.responses);
            } else if (
              _.isEqual(grouptype, "sponsor") &&
              sponsor &&
              sponsor.responses
            ) {
              jsonData = JSON.parse(sponsor.responses);
            }

            if (jsonData) {
              // console.log('jsonData :- ', jsonData);
              let match = jsonData.filter((obj) => {
                return obj.id === rep || obj.name === rep;
              });
              // console.log({ match, rep });
              // console.log('match :- ', match);
              if (match.length > 0) {
                let key = match[0].key;
                if (
                  key !== "hyperlink" &&
                  key !== "label" &&
                  key !== "paragraph"
                ) {
                  let value = match[0].value ? match[0].value : "";
                  // console.log("value :-", value);
                  if (key === "checkboxes" && Array.isArray(value)) {
                    let options = match[0].options;
                    let matchedVal = [];

                    value.forEach((element) => {
                      let m = options?.filter((o) => {
                        return o.text === element || o.value === element;
                      });
                      if (m && m.length > 0) {
                        matchedVal.push(m[0].text);
                      }
                    });
                    customVal = matchedVal.join(", ");
                  } else if (
                    (key === "dropdown" || key === "radiobuttons") &&
                    value !== ""
                  ) {
                    let options = match[0].options;

                    let m = options?.filter((o) => {
                      return o.text === value || o.value === value;
                    });
                    if (m && m.length > 0) {
                      customVal = m[0].text;
                    }
                  } else if (key === "datepicker" && value !== "") {
                    customVal = format(new Date(value), "yyyy-MM-dd");
                  } else {
                    customVal = value;
                  }
                }
              }
            } else {
              customVal = identifierString;
            }
          }
          text = value.textValue.replace(`{{${rep}}}`, customVal);
        } else {
          text = value.textValue;
        }
      } else {
        text = identifierString;
      }
    }

    return text;
  };

  const ensureFontLoaded = (fontFamily) => {
    const fontLinkId = `font-${fontFamily.replace(/\s+/g, "-")}`;
    if (!document.getElementById(fontLinkId)) {
      // Construct the Google Fonts URL for the font
      const fontLink = document.createElement("link");
      fontLink.id = fontLinkId;
      fontLink.crossOrigin = "anonymous";
      fontLink.href = `https://fonts.googleapis.com/css2?family=${fontFamily.replace(
        /\s+/g,
        "+"
      )}&display=swap`;
      fontLink.rel = "stylesheet";

      document.head.appendChild(fontLink);
    }
  };

  // Convert cm to pixels
  const convertCmToPixelDouble = (val) => {
    const pixel = val * 37.795; // 1 cm = 37.795275591 pixels at 96 PPI
    return pixel * 2; // Return the value multiplied by 2 for precision adjustments
  };

  // Extract canvas size from data
  const canvasSize = socialposts?.[selectedIDX]?.canvas_size
    .split("#")
    .map((dim) => parseFloat(dim));

  // Calculate scaling factor
  const originalWidthPx = convertCmToPixelDouble(canvasSize?.[0]);
  const originalHeightPx = convertCmToPixelDouble(canvasSize?.[1]);
  const scaleX = 310 / originalWidthPx;
  const scaleY = 310 / originalHeightPx;

  const isRectangle = canvasSize?.[0] === 24.06;

  // Use the smaller ratio to maintain aspect ratio
  const scaleRatio = Math.min(scaleX, scaleY);

  const renderLayout = (layout, boostgroupid) => {
    const username = orderData?.data?.username?.split(" ");
    let userDetails = !_.isEmpty(socialDetails)
      ? socialDetails
      : {
          firstname: username?.[0],
          lastname: username?.[1],
          username: orderData?.data?.username,
          profileurl: "",
          email: orderData?.data?.email,
        };

    if (fromThankyouPage && !_.isEmpty(locationState)) {
      userDetails = locationState;
      userDetails.username = `${locationState?.firstname} ${locationState?.lastname}`;
    }

    if (matched && matched.profileurl) {
      userDetails.profileurl = matched.profileurl;
    }
    if (matched) {
      userDetails.username = `${matched?.firstname} ${matched?.lastname}`;
      userDetails.firstname = matched?.firstname;
      userDetails.lastname = matched?.lastname;
      userDetails.email = matched?.email;
      userDetails.userqrstring = matched?.userqrstring;
    }
    return _.map(layout, (value, index) => {
      let customStyle = { ...value.style };
      const scaleRatio = 310 / Math.max(originalWidthPx, originalHeightPx); // Uniform scaling for largest dimension

      // Adjust position calculations (direct scaling from original positions)
      let templateX =
        value.x *
        scaleRatio *
        (originalWidthPx == originalHeightPx ? 3.3 : 6.45); // Scale X position
      let templateY =
        value.y *
        scaleRatio *
        (originalWidthPx == originalHeightPx ? 3.3 : 6.45); // Scale Y position;

      // Apply transformed position
      customStyle.transform = `translate(${templateX}px, ${templateY}px)`;

      // Adjust width and height based on the scale ratio
      if (value.htmlType === "image") {
        delete customStyle.top;
        delete customStyle.left;
        customStyle.width = `${parseInt(value.style.width)}px`;
        customStyle.height = `${
          parseInt(value.style.height) -
          (originalWidthPx == originalHeightPx ? 0 : 16)
        }px`;

        let sponsor = matched ? matched?.sponsor_by_sponsoridfk : null;
        let exhibitor = matched ? matched?.exhibitors_by_exhibitoridfk : null;
        let speaker = matched ? matched?.speaker_by_speakeridfk : null;

        switch (value.name) {
          case "#event_logo":
            value.imageValue = eventData.eventicon
              ? `${CDN_BASE_IMAGES_URL}/${eventData.eventicon}`
              : "";
            break;
          case "#profil_logo":
            value.imageValue =
              userDetails?.profileurl &&
              userDetails?.profileurl !== "" &&
              !userDetails?.profileurl.includes("eventify")
                ? userDetails?.profileurl
                : userDetails?.profileurl && userDetails?.profileurl !== ""
                ? `${CDN_BASE_IMAGES_URL}/${userDetails?.profileurl}`
                : userIcon;
            previewData.current = {
              username: userDetails.username,
              profileImage: value.imageValue,
            };
            break;
          case "#spk_profileimage":
            value.imageValue = `${CDN_BASE_IMAGES_URL}/${speaker?.profileimage}`;
            break;
          case "#exh_profileimage":
            value.imageValue = `${CDN_BASE_IMAGES_URL}/${exhibitor?.profileimage}`;
            break;
          case "#exh_bannerimage":
            value.imageValue = `${CDN_BASE_IMAGES_URL}/${exhibitor?.bannerimage}`;
            break;
          case "#spn_logoimgpath":
            value.imageValue = `${CDN_BASE_IMAGES_URL}/${sponsor?.logoimgpath}`;
            break;
          case "#spn_bannerimage":
            value.imageValue = `${CDN_BASE_IMAGES_URL}/${sponsor?.bannerimage}`;
            break;
          default:
            value.imageValue = `${CDN_BASE_IMAGES_URL}/${value.imageValue}`;
            break;
        }
      }

      if (value.htmlType === "zoominout") {
        customStyle.width = `${parseInt(value.style.width)}px`;
        customStyle.height = `${parseInt(value.style.height)}px`;
      }

      if ((value.htmlType === "div" || value.htmlType === "input") && !layout) {
        customStyle.width =
          customStyle.width === "max-content"
            ? "100%"
            : `${parseInt(customStyle.width)}px`;
      }
      if (value.style && "fontFamily" in value.style) {
        ensureFontLoaded(value.style.fontFamily);
      }

      // Adjust z-index for stacking
      customStyle.zIndex = 2000 + (layout.length - value.displayOrder);

      // Render the appropriate HTML based on `htmlType`
      return !value.hidden ? (
        <>
          {value.htmlType === "image" ? (
            <img
              key={`key_preview_${index}`}
              id={value.name}
              name={value.name}
              src={value.imageValue}
              style={{
                ...customStyle,
                borderRadius: value?.radius ? `${value?.radius}px` : "none",
              }}
              draggable="false"
              alt={value.name}
            />
          ) : value.htmlType === "input" && !layout ? (
            <span
              key={`key_preview_${index}`}
              style={{
                ...customStyle,
                border: "none",
              }}
            >
              {_.size(value.textValue) === 0
                ? renderTexts(value, boostgroupid)
                : value.textValue.split("\n").map((line, idx) => (
                    <React.Fragment key={idx}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
            </span>
          ) : value.htmlType === "zoominout" ? (
            value.name === "#external_qr_code" ? (
              userDetails?.externalqrlink &&
              userDetails?.externalqrlink !== "" && (
                <>
                  <QRCodeReact
                    key={`key_preview_${index}`}
                    size={256}
                    style={customStyle}
                    value={userDetails?.externalqrlink}
                    viewBox={`0 0 256 256`}
                  />
                </>
              )
            ) : userDetails?.userqrstring !== "" ? (
              <QRCodeReact
                key={`key_preview_${index}`}
                size={256}
                style={customStyle}
                value={userDetails?.userqrstring}
                viewBox={`0 0 256 256`}
              />
            ) : (
              <div style={{ ...customStyle,background: "white" }}>⚠️ QR Code Missing</div>
            )
          ) : (
            <span
              key={`key_preview_${index}`}
              style={{
                ...customStyle,
                border: "none",
              }}
            >
              {renderTexts(value, boostgroupid)}
            </span>
          )}
        </>
      ) : null;
    });
  };

  let disableShare = false;
  if (calledFrom === "ticket") {
    if (!matched) {
      disableShare = true;
    }
  }

  return _.isEmpty(socialposts) || disableShare ? (
    <></>
  ) : (
    <div className="w-full grid grid-cols-1 md:grid-cols-[4fr_8fr] gap-6 p-5 rounded-lg bg-white border mb-12 shadow">
      <div className="flex flex-col gap-6">
        {sessions?.length > 0 && (
          <select
            className="input-field common-field bg-white"
            onChange={(e) => setCurrentIndex(e.target.value)}
          >
            {_.map(sessions, (ea, idx) => (
              <option value={idx} key={idx?.title}>
                {ea.title}
              </option>
            ))}
          </select>
        )}
        <div
          ref={containerRef}
          className={`border rounded shadow overflow-hidden w-[310px] ${
            isRectangle ? "h-[177px] my-16" : "h-[310px]"
          }`}
        >
          <div
            className="shadow-md"
            style={{
              width: originalWidthPx,
              height: originalHeightPx,
              position: "relative",
              transform: `scale(${scaleRatio})`,
              transformOrigin: "top left",
            }}
          >
            {renderLayout(
              socialposts?.[selectedIDX]?.layoutjson
                ? JSON.parse(socialposts[selectedIDX].layoutjson)
                : [],
              socialposts?.[selectedIDX]?.groupid ?? 0
            )}
          </div>
        </div>

        {/* Horizontal scrollable section with arrows */}
        <div className="relative w-[310px]">
          {/* Scrollable container */}
          <div
            className="flex items-center space-x-3 overflow-x-auto hide-scrollBar relative"
            style={{ scrollBehavior: "smooth" }}
            ref={scrollContainerRef}
          >
            {_.map(socialposts, (ea, idx) => {
              // Extract and parse layout JSON
              const layout = ea.layoutjson ? JSON.parse(ea.layoutjson) : [];

              // Extract canvas size
              const [canvasWidth, canvasHeight] = ea.canvas_size
                .split("#")
                .map((dim) => parseFloat(dim));

              // Convert to pixels (same conversion method as before)
              const originalWidthPx = convertCmToPixelDouble(canvasWidth);
              const originalHeightPx = convertCmToPixelDouble(canvasHeight);

              // Scaling for preview (fit within 75px while maintaining aspect ratio)
              const previewSize = 75;
              const scaleX = previewSize / originalWidthPx;
              const scaleY = previewSize / originalHeightPx;
              const scaleRatio = Math.min(scaleX, scaleY); // Maintain aspect ratio

              // Check if canvas width is 24.06 (convert if necessary)
              const isRectangle1 = canvasWidth === 24.06;

              return (
                <div
                  key={idx}
                  className={`relative flex-shrink-0 cursor-pointer border rounded overflow-hidden ${
                    isRectangle1 ? "w-[75px] h-[45px]" : "w-[75px] h-[75px]"
                  }`} // Make wider if it's a rectangle
                  onClick={() => setSelectedIDX(idx)}
                >
                  <div
                    className="absolute top-0 left-0"
                    style={{
                      width: originalWidthPx,
                      height: originalHeightPx,
                      transform: `scale(${scaleRatio})`,
                      transformOrigin: "top left",
                      position: "relative",
                    }}
                  >
                    {renderLayout(layout, ea?.groupid ?? 0)}
                  </div>

                  {selectedIDX === idx && (
                    <div className="absolute inset-0 bg-[#105EFB] bg-opacity-50 flex items-center justify-center">
                      <img src={tickIcon} alt="tickIcon" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {socialposts?.length > 3 && (
            <>
              {/* Fog effect */}
              <div className="absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-white to-transparent pointer-events-none"></div>
              <div className="absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-white to-transparent pointer-events-none"></div>

              {/* Arrow buttons */}
              <img
                className="absolute h-fit cursor-pointer left-0 top-1/2 transform rotate-180 -translate-y-1/2 bg-opacity-70 rounded-full p-2"
                onClick={() =>
                  scrollContainerRef.current.scrollBy({
                    left: -100,
                    behavior: "smooth",
                  })
                }
                src={arrowIcon}
                alt="left Arrow"
              />

              <img
                className="absolute cursor-pointer right-0 top-1/2 transform -translate-y-1/2 bg-opacity-70 rounded-full p-2"
                onClick={() =>
                  scrollContainerRef.current.scrollBy({
                    left: 100,
                    behavior: "smooth",
                  })
                }
                src={arrowIcon}
                alt="right Arrow"
              />
            </>
          )}
        </div>
      </div>

      <div className="flex flex-col space-y-3 justify-center">
        <div className="text-2xl font-semibold mt-5">
          {LocaleStrings.kJoinTheBuzz}
        </div>
        <div className="text-md font-normal text-[#475467]">
          {LocaleStrings.kShareDescription.replace(
            "###EVENTNAME###",
            eventData?.eventname
          )}
        </div>
        <button
          className={`w-full h-10 px-4 py-2 gap-2 border rounded-lg  flex justify-center items-center text-center ${
            loading === "linkedin" ? "animate-pulse" : ""
          }`}
          type="button"
          onClick={() =>
            loading === "" ? prepareShareData("linkedin") : undefined
          }
        >
          <img src={linkedinIcon} alt="LinkedIn Icon" className="" />
          <div className=" text-sm font-bold text-nowrap">
            {LocaleStrings.kLinkedInpostButton}
          </div>
        </button>
        <button
          className={`w-full h-10 px-4 py-2 gap-2 border rounded-lg  flex justify-center items-center text-center ${
            loading === "facebook" ? "animate-pulse" : ""
          }`}
          type="button"
          onClick={() =>
            loading === "" ? prepareShareData("facebook") : undefined
          }
        >
          <img src={facebookIcon} alt="Facebook Icon" className="" />
          <div className="text-sm font-bold text-nowrap">
            {LocaleStrings.kFacebookpostButton}
          </div>
        </button>
      </div>

      {/* Preview Modal  */}
      {modal.show && (
        <div class="fixed z-10 inset-0 overflow-y-auto">
          <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div class="fixed inset-0 transition-opacity">
              <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
            <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
            <div class="inline-block align-bottom bg-[#F9FAFB] rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl sm:w-full sm:p-6">
              <div className="max-w-4xl mx-auto">
                {/* Preview Section */}
                <h3 className="text-gray-700 font-semibold mb-2">
                  See how it will appear on social media
                </h3>
                <div className="border rounded-lg shadow-lg">
                  <div className="flex items-center space-x-3 p-4">
                    <img
                      className="w-10 h-10 rounded-full"
                      src={previewData?.current?.profileImage}
                      alt="Profile"
                    />
                    <div>
                      <p className="font-semibold text-gray-800">
                        {previewData?.current?.username}
                      </p>
                      <p className="text-sm text-gray-500">Just now</p>
                    </div>
                  </div>
                  <p className="px-4" style={{ whiteSpace: "pre-wrap" }}>
                    {caption}
                  </p>
                  <div className="mt-4 border rounded-lg overflow-hidden">
                    <img className="w-full" src={image} alt="Event" />
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                  <button
                    type="button"
                    disabled={postLoading}
                    onClick={() =>
                      shareMediaPost(
                        { caption: caption, base64_image: image },
                        modal.type,
                        () => {
                          setModal({ show: false, type: "" });
                        }
                      )
                    }
                    class="theme-button-md"
                  >
                    <svg
                      className={classNames(
                        postLoading ? "" : "hidden",
                        "cust-btn-spinner"
                      )}
                      viewBox="0 0 1024 1024"
                      focusable="false"
                      data-icon="btnloading"
                      width="1em"
                      height="1em"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                    </svg>{" "}
                    Post
                  </button>
                </span>
                <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                  <button
                    type="button"
                    onClick={() => setModal({ show: false, type: "" })}
                    class="default-button-md"
                  >
                    Cancel
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SocialShare;
